module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.09324c9e.png";